import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiConfig, getApiUrl } from 'src/config/apiConfig';
import axiosIn from 'src/middlewares/axiosInterceptor';

const initialState: any = {
  fetchedTableData: {
    // TODO : Implemented also in appGeneralReducer. This is not in use. But tables require this.
    tabId_main: [],
  },
  fetchedStatus: {
    tabId_main: [],
  },
  currentPaginationOfTabs: {
    tabId_main: 0,
  },
  currentPageSizeOfTabs: {
    tabId_main: 25,
  },
  currentTab: 'tabId_main',

  searchForm: {},

  actionButtonStates: { filter: { show: false, data: {} }, order: { show: false, data: {} }, plus: { show: false, data: {} } },
};

export const fetchTargetsTable: any = createAsyncThunk<any, any>('TargetsPageSlice/fetchedTableData_main', async ({ page, pageSize, shouldUpdateState }: any, { getState }) => {
  let state = getState() as any;
  state = state.targetsReducer;

  const createQueryUrl = () => {
    try {
      const queryParams: any = {
        page: page ? page : state.currentPaginationOfTabs?.[state.currentTab] + 1, // Gives the error here
        page_size: pageSize ? pageSize : state.currentPageSizeOfTabs[state.currentTab],
      };

      // Remove empty or null fields from the query params
      const filteredQueryParams = Object.entries(queryParams)
        .filter(([_, value]) => value !== null && value !== '' && value !== undefined)
        .map(([key, value]: any) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

      // Construct the final URL
      return getApiUrl(apiConfig.schedule_scan) + '?' + filteredQueryParams;
    } catch (error) {
      console.error('error: ', error);
    }
  };

  const curl = createQueryUrl() || '';

  // return { res: { data: mockdata, total: 100 }, shouldUpdateState: shouldUpdateState }; // TODO TEST

  if (state.currentTab) {
    try {
      const response = await axiosIn.get(curl);
      return { res: response.data, shouldUpdateState: shouldUpdateState !== false };
    } catch (error) {
      console.error('Fetch error:', error);
      throw error;
    }
  }
});

export const TargetsPageSlice: any = createSlice({
  name: 'TargetsPageSlice',
  initialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setTargetsSearchForm: (state, action) => {
      const { key, value } = action.payload;
      state.searchForm[key] = value;
    },
    setDataForTab: (state, action) => {
      const { tabId, data } = action.payload;
      state.fetchedTableData[tabId] = data;
    },
    setCurrentPaginationOfTheTab: (state, action) => {
      const { tabId, pagination } = action.payload;
      state.currentPaginationOfTabs[tabId] = pagination;
    },
    setCurrentPageSizeOfTabs: (state, action) => {
      const { tabId, pageSize } = action.payload;
      state.currentPageSizeOfTabs[tabId] = pageSize;
    },
    targetsClearForm: (state) => {
      state.searchForm = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTargetsTable.fulfilled, (state: any, action: any) => {
      const { res, shouldUpdateState } = action.payload;
      const { currentTab } = state;
      // Only update the state if shouldUpdateState is true
      if (shouldUpdateState) {
        state.fetchedTableData[currentTab] = res;
      }
    });
  },
});

export const {
  //
  setTargetsSearchForm,
  setCurrentTab,
  setCurrentPaginationOfTheTab,
  setCurrentPageSizeOfTabs, 
  setDataForTab,
  targetsClearForm,
} = TargetsPageSlice.actions;

export default TargetsPageSlice.reducer;
